import React, { useEffect } from 'react';
import { useQuoteDetailStore } from "../../../hooks/quote-detail";
import csvIcon from 'src/assets/images/csv.svg'
import excelIcon from 'src/assets/images/xls.svg'
import Helper from 'src/support/Helper';
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import Constants from 'src/support/Constants';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

import HelperAdobeEvent from "src/support/HelperAdobeEvent";
const c = System.getParams();

export function CustomerInformation(props) {
    const [{ contactName, contactEmail, quoteRequestedDate, quoteExpirationDate }, { }, { }] = useQuoteDetailStore();
    const [{ }, { fetch_submitted_quote_export_url }, { }] = useQuoteStore();
    const [__check] = useAxiosIndicatorCheck();
    const { quoteNumber } = props;
    const provisionalId = c.quoteProvisionalNumber;


    useEffect(() => {
        const qtHeader = { quoteNumber: quoteNumber, quoteRequestedDate: quoteRequestedDate, quoteExpirationDate: quoteExpirationDate, }
        sessionStorage.setItem("quoteHeader", JSON.stringify(qtHeader))
    }, [quoteNumber, quoteRequestedDate, quoteExpirationDate]);

    const exportQuote = async (fileType) => {
        if (quoteNumber != undefined && fileType !== '') {
            let _params = { "provisionalId": provisionalId, "fileType": fileType };
            if (c.quote_number) {
                _params = { ..._params, "quoteNumber": quoteNumber }
            }
            let result = await fetch_submitted_quote_export_url(_params)
            if (result?.size > 0) {
                let dwdDetails = {
                    "fileType": fileType,
                    "dwdType": "Quote",
                    "fileName": "Quotes_" + provisionalId + "." + fileType
                }
                showDownloadMessage(dwdDetails);
                exportEvent(fileType)
            }
        }
    };

    const showDownloadMessage = (dwdDetails) => {
        System.alert(Constants.downloadMsg, 'success');
        // downloadComplete({dwdDetails});
    }

    //By Ramya Kannan [Quote-dowmload ]
    function downloadComplete(dwdDetails) {
        localStorage.setItem("adobeEventType", "downloads");
        HelperAdobeEvent.trackingAdobeEvent(dwdDetails);
    }

    //By Ramya [Export Event - Cart ADobe script]
    function exportEvent(type) {
        localStorage.setItem("adobeEventType", "exportEvent");
        let exportDetails = {
            fileExtension: type,
            exportType: "Quote"
        }
        let QuoteDetails = {
            quoteID: quoteNumber,
            quoteType: "online"
        };
        if (Object.keys(exportDetails).length && Object.keys(QuoteDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ QuoteDetails, exportDetails });
        }

    }

    return (
        <>
            <div className="pcn-line-divider"> </div>
            <a href={Quote.getSubmittedQuoteAbsoluteUrl()}>Submitted Quote </a>
            <div className="customer-info">
                <div className="bs5 row">
                    <div className="col-7">
                        <h1 className='page-heading'>Customer Information</h1>
                        <ul className="list-inline">
                            <li><a className="customer-link" href={void (0)}><b>
                                <i className="fa fa-user" aria-hidden="true"></i>Buyer:</b> {(contactName && contactName.trim()) ? contactName : Constants.noValue}
                            </a>
                            </li>
                            <li><a className="customer-link" href={void (0)}><b><i className="fa fa-envelope"
                                aria-hidden="true"></i> Email:</b> {(contactEmail && contactEmail.trim()) ? contactEmail : Constants.noValue}
                            </a>
                            </li>

                        </ul>
                    </div>
                    <div className="col-5 text-right">
                        <div className="d-inline-flex flex-column align-items-end">
                            <p className="date-requested"><i> Date requested: {quoteRequestedDate && Helper.dateFormatFromString(quoteRequestedDate)} | Expiration:
                                {quoteExpirationDate && Helper.dateFormatFromString(quoteExpirationDate)}</i></p>
                            <h3 className="mt-0">Export/Download Quote</h3>
                            <ul className="list-inline">
                                {__check('EXPORT_URL', { inline: true }).render}
                                {!__check(['EXPORT_URL']).status &&
                                    <>
                                        <li><a className="customer-link bs5 d-flex align-items-center" href={void (0)}><i><img src={csvIcon} /></i>
                                            <span className="bs5 text-blue pt-1" onClick={() => exportQuote('csv')}>CSV</span>
                                        </a></li>
                                        <li><a className="customer-link bs5 d-flex align-items-center" href={void (0)}><i><img src={excelIcon} alt='Export/Download XLSX' /></i>
                                            <span className="bs5 text-blue pt-1" onClick={() => exportQuote('xlsx')}>XLSX</span>
                                        </a></li>
                                    </>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
